var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMessages(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 57C19.746 57 9 46.254 9 33S19.746 9 33 9s24 10.746 24 24-10.746 24-24 24zm0 0",
    fill: "#4fc831"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 16.602c-10.031 0-18.191 7.093-18.191 15.816 0 4.895 2.64 9.543 7.078 12.527-.106.832-.524 2.848-2.188 5.211l-.875 1.239 1.567.003c4.293 0 7.195-2.628 8.152-3.64 1.45.316 2.945.48 4.457.48 10.031 0 18.191-7.097 18.191-15.82 0-8.723-8.16-15.816-18.191-15.816zm0 0",
    fill: "#fff"
  })));
}

export default SvgMessages;